import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import * as PROJECT_CODE from '../../../constants/projectCode';
import lotMap from '../../../assets/lotMap.png';
import siteplan from '../../../assets/siteplan.jpg';
import ImageMapper from 'react-img-mapper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ClearIcon from '@material-ui/icons/Clear';

import '../Doc.css';
import {
	Box,
	Checkbox,
	CircularProgress,
	FormControl,
	FormControlLabel,
	FormLabel,
	LinearProgress,
	Paper,
	Radio,
	RadioGroup,
	Typography,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import './ModelHome.css';
import {
	CheckBox,
	CropPortraitTwoTone,
	SettingsTwoTone,
} from '@material-ui/icons';

function ModelHomes({
	setLotList,
	elevationList,
	lotList,
	pricingDetails,
	exteriorImage,
	setExteriorImage,
	elevationPriceSum,
	setBuildingPriceSum,
	buildingPriceSum,
	setLotPriceSum,
	lotPriceSum,
	setElevationPrice,
	elevationPrice,
	setElevationId,
	elevationId,
	setLotPrice,
	lotPrice,
	setIsCompleted,
	isCompleted,
	setFloorplan,
	floorplan,
	setDisable,
	disable,
	setTotalMainFloor,
	totalMainFloor,
	setElevationTab,
	elevationTab,
	optionSum,
	setOptionSum,
	premiumDescription,
	setOptionSelected,
	floorPlanChecked,
	setFloorPlanChecked,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [hoveredArea, setHoveredArea] = useState();
	const [loading, setLoading] = useState(false);
	const [progress, setProgress] = useState(0);
	const [mainImage, setMainImage] = useState([]);
	const [subImage, setSubImage] = useState([]);
	const [showLightbox, setShowLightbox] = useState(false);
	const [currentImage, setCurrentImage] = useState();
	const [floorplanTitle, setFloorplanTitle] = useState([
		'Floor Plan',
		'Options',
	]);
	const [floorplanTab, setFloorplanTab] = useState(0);
	const [mainFloorPrice, setMainFloorPrice] = useState();
	const [buildingNameState, setBuildingNameState] = useState();

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	const handleTab = async (e) => {
		setLoading(true);
		var buildingName = e.currentTarget.dataset.buildingname;
		console.log('buildingNamebuildingName', buildingName);
		setBuildingNameState(buildingName);
		var elevationId = e.currentTarget.dataset.buildingid;
		var elevationIdToUpper = elevationId.toUpperCase();
		setDisable({ ...disable, modelhomes: false });
		setElevationId(elevationId);

		console.log('Clicked');
		console.log(
			'BuildingName: ' + buildingName + ', ElevationId: ' + elevationId
		);

		var storageRef = firebase
			.storage()
			.ref(PROJECT_CODE.projectCode + '/buildingExteriors/');

		storageRef
			.child(buildingName + '/' + elevationId.toLowerCase())
			.listAll()
			.then(function (result) {
				result.items.forEach(function (imageRef) {
					displayImage(imageRef);

					console.log('imageRef: ' + imageRef);
				});
			});

		function displayImage(images) {
			images.getDownloadURL().then(function (url) {
				console.log('This is the url: ' + url);
				setExteriorImage(url);
			});
		}

		var floorplanRef = firebase
			.storage()
			.ref(PROJECT_CODE.projectCode + '/floorPlans/');

		await floorplanRef
			.child(buildingName + '/' + elevationId.toLowerCase())
			.listAll()
			.then(function (result) {
				console.log('This is floorplanref result', result.items);
				if (result.items.length > 0) {
					result.items.forEach(function (imageRef) {
						displayFloorplanImage(imageRef);
					});
				} else {
					console.log('I am here in the else');
					displayFloorplanImage(null);
				}
			});

		var mainImageArr = [];

		function displayFloorplanImage(images) {
			console.log('This is the main imageS: ', images);
			if (images !== null) {
				images.getDownloadURL().then(function (url) {
					mainImageArr.push(url);
					setMainImage([...mainImageArr]);
					setLoading(false);
				});
			} else {
				setMainImage();
				setLoading(false);
			}
		}

		await firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/buildingInfo/' +
					buildingName +
					'/priceList/'
			)
			.orderByChild('id')
			.equalTo(elevationId)
			.once('value', (snapshot) => {
				var elevationPriceState;
				snapshot.forEach((priceItem) => {
					elevationPriceState = priceItem.val().price;
				});

				setElevationPrice(elevationPriceState);
				setElevationId(elevationIdToUpper);
			});
	};

	const handleTabFloorplan = (e) => {
		console.log('handleTabFloorplan', e);
	};

	const handleChange = (event, newValue) => {
		console.log('newValuee', newValue);
		setSubImage();
		setFloorplanTab(0);
		setFloorPlanChecked({});
		setElevationTab(newValue);
	};

	const handleChangeFloorplanTab = (event, newValue) => {
		console.log('handleChangeFloorplanTab newValue:', newValue);
		setFloorplanTab(newValue);

		if (newValue === 0) {
			setFloorPlanChecked({});
		} else if (newValue === 1) {
			console.log('get the elevation tab', elevationTab);
			console.log('get the elevation id', elevationId);
			console.log('get the buildingname state', buildingNameState);

			firebase
				.database()
				.ref(
					'/kavtek_clients/' +
						PROJECT_CODE.projectCode +
						'/buildingInfo/' +
						buildingNameState +
						'/priceList/' +
						elevationTab +
						'/options/'
				)
				.once('value', (snapshot) => {
					console.log(
						'handleChangeFloorplanTab snapshot',
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/buildingInfo/' +
							buildingNameState +
							'/priceList/' +
							elevationTab +
							'/options/'
					);
					var obj;
					var optionsArr = [];
					var addOptionPrice = [];
					snapshot.forEach((snap) => {
						var name = snap?.val().name;
						var price = snap?.val().price;
						var key = snap.key;
						addOptionPrice.push(price);

						obj = {
							key: key,
							name: name,
							price: price,
						};
						optionsArr.push(obj);
					});

					console.log('This is the opntionArr', optionsArr);

					setSubImage(optionsArr);
					setOptionSum(addOptionPrice.reduce((a, b) => a + b, 0));
				});
		}
	};

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		elevationTab: {
			backgroundColor: '#F1F5F8',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			borderRadius: '8px',
		},
		progressBar: {
			width: '100%',
			padding: '10px',
		},
	}));

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => (
		<Tabs
			{...props}
			TabIndicatorProps={{ children: <span /> }}
			variant='scrollable'
		/>
	));

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#2662F0',
			textTransform: 'uppercase',
			'&.Mui-selected': {
				backgroundColor: '#FFFFFF',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const styles = useStyles();

	// PROGRESS BAR -------
	var MIN = 0;

	const normaliseElevationPrice = (value) => ((value - MIN) * 100) / 0;

	const normaliseTotalOptions = (value) =>
		((value - MIN) * 100) / (optionSum - MIN);

	const normaliseLotPrice = (value) => ((value - MIN) * 100) / 0;

	const normaliseTotalPrice = (value) => ((value - MIN) * 100) / 0;

	const ElevationProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#F17105',
		},
	}))(LinearProgress);

	const OptionProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#10ff00',
		},
	}))(LinearProgress);

	const LotProgress = withStyles((theme) => ({
		root: {
			height: 7,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#6665DD',
		},
	}))(LinearProgress);

	const TotalProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#0496FF',
		},
	}))(LinearProgress);
	// --------------------

	const handleFloorplanCheck = (e) => {
		//not actually floor plans but options now
		console.log('handleFloorplanCheck e', e.target.id);

		if (
			floorPlanChecked[e.target.id] !== null &&
			floorPlanChecked[e.target.id] !== undefined
		) {
			if (e.target.checked === false)
				delete floorPlanChecked[e.target.id];
			setFloorPlanChecked({
				...floorPlanChecked,
			});
		} else {
			setFloorPlanChecked({
				...floorPlanChecked,
				[e.target.id]:
					e.target.checked === true
						? { value: e.target.value, name: e.target.name }
						: 0,
			});
		}
	};

	useEffect(() => {
		var sum = 0;

		if (floorPlanChecked) {
			var floorplanKeys = Object.keys(floorPlanChecked);

			console.log('adddf', floorplanKeys);

			var priceArr = [];

			floorplanKeys.forEach((key) => {
				var price = parseInt(floorPlanChecked[key]['value']);

				priceArr.push(price);
			});

			console.log(
				'sum of floor: ',
				priceArr.reduce((a, b) => a + b, 0)
			);
			console.log('Current totalmaiunfloorplanm ', totalMainFloor);

			setTotalMainFloor(priceArr.reduce((a, b) => a + b, 0));

			// var result = arr?.reduce(function (acc, val) {
			// 	var o = acc
			// 		.filter(function (obj) {
			// 			return obj.name == val.name;
			// 		})
			// 		.pop() || { name: val.name, value: 0 };

			// 	o.value += val.value;
			// 	acc.push(o);
			// 	return acc;
			// }, []);

			// console.log(result);
		}

		console.log('useeefect floorplanChecked', floorPlanChecked);
	}, [floorPlanChecked]);

	return (
		<>
			<div className='details_wrapper'>
				<div className='elevation_card doc_card'>
					<div className='card_title'>Elevation</div>
					{elevationList[0] === undefined ||
					elevationList[0] === '' ? (
						<div className='empty_state_handler'>
							Please choose a building in the Model Homes.
						</div>
					) : (
						<div className={styles.root}>
							{console.log(
								'elevationTab: ' + elevationTab && elevationTab
							)}
							<div className={styles.elevationTab}>
								<StyledTabs
									value={elevationTab && elevationTab}
									onChange={handleChange}
									centered
								>
									{elevationList?.map((elevation) => {
										return (
											<StyledTab
												label={elevation.elevationId}
												onClick={(e) => handleTab(e)}
												data-buildingid={
													elevation.elevationId
												}
												data-buildingname={
													elevation.buildingName
												}
											/>
										);
									})}
								</StyledTabs>
							</div>
						</div>
					)}
					<div className='building_img'>
						{loading && (
							<div className='loading_layout'>
								<CircularProgress
									style={{
										position: 'absolute',
										left: '50%',
										top: '15%',
									}}
								/>
							</div>
						)}
						{exteriorImage && (
							<img src={exteriorImage && exteriorImage} alt='' />
						)}
					</div>
				</div>
				<div className='floorplan_card doc_card'>
					<div className='card_title'>
						<div className={styles.root}>
							<div className={styles.elevationTab}>
								<StyledTabs
									value={floorplanTab}
									onChange={handleChangeFloorplanTab}
									centered
								>
									{floorplanTitle?.map((lot) => {
										return (
											<StyledTab
												label={lot}
												onClick={(e) =>
													handleTabFloorplan(e)
												}
											/>
										);
									})}
								</StyledTabs>
							</div>
						</div>
					</div>
					{elevationId === undefined || elevationId === '' ? (
						<div className='empty_state_handler'>
							Please choose an elevation in the elevation card.
						</div>
					) : (
						<>
							{floorplanTab === 0 ? (
								<div className='floorplan_carousel_container'>
									{mainImage ? (
										<Carousel
											autoPlay={false}
											showArrows={true}
											renderIndicator={false}
											centerMode={true}
											swipeable={false}
											showStatus={false}
											emulateTouch={true}
											infiniteLoop={false}
											showIndicators={true}
											showThumbs={true}
										>
											{mainImage?.map((item) => {
												return (
													<div className='floorplan-view'>
														<div className='img-floorplan-container'>
															<img
																src={item}
																className='img-fluid'
																alt='tst'
															/>
														</div>
														<br />
														<div
															className='zoomin-icon btn btn-primary'
															onClick={() => {
																setShowLightbox(
																	true
																);
																setCurrentImage(
																	item
																);
															}}
														>
															View Image{' '}
															<span>
																<ZoomInIcon />
															</span>
														</div>
													</div>
												);
											})}
										</Carousel>
									) : (
										<div className='empty_state_handler'>
											No floorplans available for this
											elevation yet.
										</div>
									)}
								</div>
							) : (
								<>
									<div className='floorplan_carousel_container'>
										{subImage ? (
											subImage.map((item, index) => {
												return (
													<div className='floorplan-view'>
														<FormControlLabel
															control={
																<Checkbox
																	id={index}
																	checked={
																		floorPlanChecked[
																			'floorplan' +
																				item.key
																		]
																	}
																	onChange={(
																		e
																	) =>
																		handleFloorplanCheck(
																			e
																		)
																	}
																	value={
																		item.price
																	}
																	name={
																		item.name
																	}
																/>
															}
															label={`${item.name} - $${item.price}`}
															labelPlacement='right'
														/>
													</div>
												);
											})
										) : (
											<div className='empty_state_handler'>
												No options available for this
												floorplan yet.
											</div>
										)}
									</div>
								</>
							)}
						</>
					)}
				</div>
			</div>
			<div className='siteplan_wrapper doc_card'>
				{console.log(
					floorPlanChecked,
					'Total Main Floor',
					totalMainFloor,
					' The floorplan is: ' + floorplan
				)}
				<div className='card_title'>Price</div>
				{elevationId === undefined || elevationId === '' ? (
					<div className='empty_state_handler'>
						Please choose a floor plan.
					</div>
				) : (
					<>
						<div className='elevation_progress'>
							<div className={styles.progressBar}>
								<ElevationProgress
									variant='determinate'
									value={normaliseElevationPrice(
										elevationPrice
									)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										$
										{elevationPrice
											? numberWithCommas(
													elevationPrice.toFixed(2)
											  )
											: 0}
									</div>
									<div className='price_legend'>
										Elevation{' '}
										{elevationId === undefined ||
										elevationId === ''
											? 'A'
											: elevationId}
									</div>
								</div>
							</div>
						</div>
						<div className='option_progress'>
							<div className={styles.progressBar}>
								<OptionProgress
									variant='determinate'
									value={normaliseTotalOptions(
										totalMainFloor
									)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										$
										{totalMainFloor
											? numberWithCommas(
													totalMainFloor.toFixed(2)
											  )
											: 0}
									</div>
									<div className='price_legend'>Options</div>
								</div>
							</div>
						</div>
						<div className='lot_progress'>
							<div className={styles.progressBar}>
								<LotProgress
									variant='determinate'
									value={normaliseLotPrice(lotPrice)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										${numberWithCommas(lotPrice.toFixed(2))}{' '}
										{premiumDescription}
									</div>
									<div className='price_legend'>
										Lot {pricingDetails[0]?.id}
									</div>
								</div>
							</div>
						</div>
						<div className='total_progress'>
							<div className={styles.progressBar}>
								<TotalProgress
									variant='determinate'
									value={normaliseTotalPrice(
										elevationPrice + lotPrice
									)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										$
										{numberWithCommas(
											(
												+elevationPrice +
												+lotPrice +
												+totalMainFloor
											).toFixed(2)
										)}
									</div>
									<div className='price_legend'>Total</div>
								</div>
							</div>
						</div>
					</>
				)}
			</div>
			{showLightbox && (
				<>
					<div
						className='back-drop'
						onClick={() => setShowLightbox(false)}
					></div>

					<div
						className='cancelBtn-lightbox'
						onClick={() => setShowLightbox(false)}
					>
						<ClearIcon className='cancelIcon' />
					</div>
				</>
			)}
			{showLightbox && (
				<div className='image-lightbox'>
					<img src={currentImage} alt='image lightbox' />
				</div>
			)}
		</>
	);
}

export default ModelHomes;
